module.exports = __webpack_public_path__ + "static/media/ArrowRightNavyBlue.2000e854.svg";